import withDatosPersonales from "../../hoc/withTrabajadores/withDatosPersonales";
import VistaDatosPersonales from "../../view/components/RegistroUsuarios/DatosPersonales/VistaDatosPersonales";

export default withDatosPersonales(VistaDatosPersonales); 